module.exports = __webpack_public_path__ + "media/images/background_goals_white-33efc5b730edcf09c6cd622809342891.png";